module.exports = "<p>\r\n  navbar works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// /var/www/backend/src/app/core/components/layout/navbar/navbar.component.html
// module id = ../../../../../src/app/core/components/layout/navbar/navbar.component.html
// module chunks = main